import { useTranslation } from 'react-i18next'

import Input from 'common/components/dataEntry/components/Input'
import Icon from 'common/components/general/Icon'

interface SearchInputProps {
  onEnterKey?: (value: string) => void
  onChange?: (value: string) => void
  defaultValue: string
}

const SearchInput = ({ onEnterKey, onChange, defaultValue }: SearchInputProps) => {
  const { t: translate } = useTranslation()

  const search = (e: any) => {
    const value = e.target.value
    if (e.keyCode == 13) {
      if (onEnterKey) onEnterKey(value !== '' ? value : null)
    }
  }

  return (
    <div>
      <div className="flex flex__space_between">
        <Input
          suffix={searchIcon}
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.value)
            }
          }}
          onKeyUp={search}
          className="mr-8"
          defaultValue={defaultValue}
          placeholder={translate('csi-dashboard.user-action-history-search.input-placeholder')}
        />
      </div>
    </div>
  )
}

const searchIcon = <Icon type="fal fa-search" fontAwesome />

export default SearchInput
